import { useEffect, useState } from "react";
import { notifyError } from "../utils/functions";

const useCmsData = () => {
  const [cmsData, setCmsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCmsData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/admin/cms`,
          {
            method: "GET",
            headers: { apikey: process.env.REACT_APP_API_KEY },
          }
        );

        if (response.status === 401) {
          return;
        }

        const data = await response.json();
        if (response.ok) {
          setCmsData(data?.data);
        } else {
          notifyError("Error fetching CMS content");
        }
      } catch (error) {
        notifyError("Error fetching CMS content");
      } finally {
        setLoading(false);
      }
    };

    fetchCmsData();
  }, []);

  return { cmsData, loading };
};

export default useCmsData;
